<div class="contract-view">
  <ng-container *ngIf="contractData">
    <div class="contract-hero">
      <div class="contract-hero__client">
        <p class="contract-hero__label">Cliente</p>
        <h2 class="contract-hero__name">{{ contractData.Client || '-' }}</h2>
        <p class="contract-hero__doc">CPF/CNPJ {{ contractData.ClientDocument || '-' }}</p>
      </div>

      <div class="contract-hero__stats">
        <div class="contract-hero__stat">
          <p class="contract-hero__stat-label">Valor do Financiamento</p>
          <p class="contract-hero__stat-value">{{ (contractData.Amount | currency: 'BRL') || '-' }}</p>
        </div>
        <div class="contract-hero__stat">
          <p class="contract-hero__stat-label">Alíquota</p>
          <p class="contract-hero__stat-value">{{ (contractData.Fee !== null && contractData.Fee !== undefined) ? (contractData.Fee | number: '1.0-2') + '%' : '-' }}</p>
        </div>
        <div class="contract-hero__stat">
          <p class="contract-hero__stat-label">Produto</p>
          <p class="contract-hero__stat-value">{{ contractData.Product || '-' }}</p>
        </div>
        <div class="contract-hero__stat">
          <p class="contract-hero__stat-label">Banco</p>
          <p class="contract-hero__stat-value">{{ (contractData.FinancialInstitution | titlecase) || '-' }}</p>
        </div>
      </div>
    </div>

    <div class="beneficiary-summary" *ngIf="totalBeneficiaries">
      <span>{{ totalBeneficiaries }} beneficiário{{ totalBeneficiaries > 1 ? 's' : '' }} • comissão total de {{ totalCommissionPercent | number: '1.0-2' }}% sobre o financiamento</span>
      <strong>{{ totalAmountToReceive | currency: 'BRL' }}</strong>
    </div>
  </ng-container>

  <div class="ui-empty-state" *ngIf="!beneficiariesList.length">
    <span class="ui-empty-state__message">Não há Beneficiários</span>
  </div>

  <div class="beneficiary-card" *ngFor="let beneficiario of beneficiariesList">
    <div class="beneficiary-card__header">
      <div class="beneficiary-card__identity">
        <app-status-badge
          [label]="beneficiaryTypeLabel(beneficiario) | uppercase"
          [tone]="beneficiaryTone(beneficiario)"
          variant="outline">
        </app-status-badge>
        <span class="beneficiary-card__name">{{ beneficiario.Name || '-' }}</span>
      </div>

      <div class="beneficiary-card__amount">
        <p class="contract-field__label">Valor a Receber</p>
        <p class="beneficiary-card__amount-value">{{ (beneficiario.Amount | currency: 'BRL') || '-' }}</p>
      </div>

      <button class="ui-btn ui-btn--secondary beneficiary-card__edit-btn" *ngIf="isCredimorar(beneficiario) && readonly" (click)="openDialogCredimorarValueEdit()">
        <app-svg-icon src="../../../../assets/icons/edit-icon.svg" width="14px" height="14px" color=""></app-svg-icon>
        Editar valor
      </button>

      <button class="ui-btn ui-btn--secondary beneficiary-card__edit-btn" *ngIf="isParceiro(beneficiario) && canEditPartnerCommission" (click)="openDialogCommissionEdit()">
        <app-svg-icon src="../../../../assets/icons/edit-icon.svg" width="14px" height="14px" color=""></app-svg-icon>
        Editar comissão
      </button>
    </div>

    <div class="beneficiary-card__grid">
      <div class="contract-field">
        <p class="contract-field__label">CPF/CNPJ</p>
        <p class="contract-field__value">{{ formatDocument(beneficiario.Document) }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Comissão</p>
        <p class="contract-field__value">{{ beneficiario.Fee | number: '1.0-2' }}%</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Base de Cálculo</p>
        <p class="contract-field__value">{{ (contractData?.Amount | currency: 'BRL') || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Previsão de Recebimento</p>
        <p class="contract-field__value">{{ (beneficiario.EstimatedPaymentDate | date: 'dd/MM/yyyy') || '—' }}</p>
        <p class="contract-field__hint" *ngIf="!beneficiario.EstimatedPaymentDate">dd/mm/aaaa</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Recebido em</p>
        <p class="contract-field__value">{{ (beneficiario.PaymentDate | date: 'dd/MM/yyyy') || '—' }}</p>
        <p class="contract-field__hint" *ngIf="!beneficiario.PaymentDate">Ainda não recebido</p>
      </div>
    </div>
  </div>
</div>
